// Mock Data for Sharad and Sons Website

export const companyInfo = {
  name: "Sharad and Sons",
  tagline: "The complete print shop",
  logo: "https://customer-assets.emergentagent.com/job_sharad-enterprise/artifacts/roc55r93_S%26S%20logo.jpg",
  contact: {
    email: "jatinmehta@sharadandsons.co.in/ishashah@sharadandsons.co.in",
    address: "GR-046/2064/65/68/105, Bhandup Industrial Estate, Pannalal Compound, L.B.S. Road, Bhandup (West), Mumbai-400078, INDIA"
  }
};

export const aboutUs = {
  title: "About Sharad and Sons",
  description: "With over 35 years of excellence in the printing industry, Sharad and Sons has established itself as a trusted name in manufacturing high-quality pharmaceutical leaflets. Our commitment to precision, compliance, and timely delivery has made us the preferred choice for pharmaceutical companies across India.",
  highlights: [
    { value: "35+", label: "Years of Excellence" },
    { value: "2400M+", label: "Leaflets Produced" },
    { value: "99.8%", label: "Quality Assurance" }
  ],
  story: "Founded in 1991, we began as a commercial printing company, building our reputation on quality, reliability, and attention to detail.\n\nIn 2006, we made a focused shift toward pharmaceutical leaflets—recognizing the growing need for precision, clarity, and compliance in healthcare communication. Since then, we have specialized exclusively in leaflet production, refining our processes to meet the highest industry standards.\n\nWith over three decades of experience, we combine our strong printing foundation with deep expertise in pharma leaflets. Our clients trust us for consistent quality, timely delivery, and uncompromising accuracy.\n\nToday, we remain dedicated to doing one thing exceptionally well—producing pharmaceutical leaflets that communicate critical information clearly and reliably."
};

export const strengths = [
  {
    id: 1,
    title: "Advanced Technology",
    description: "Equipped with the latest offset printing machines ensuring precision and vibrant color reproduction for every leaflet.",
    icon: "Cpu"
  },
  {
    id: 2,
    title: "Experienced Team",
    description: "Our skilled professionals bring decades of expertise in print production, quality control, and customer service.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Quick Turnaround",
    description: "Efficient production processes enable us to deliver large orders within tight deadlines without compromising quality.",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Cost-Effective Solutions",
    description: "Competitive pricing with flexible packages designed to meet the budget requirements of businesses of all sizes.",
    icon: "DollarSign"
  },
  {
    id: 5,
    title: "Quality Assurance",
    description: "Multi-stage quality checks ensure every leaflet meets international standards before reaching your hands.",
    icon: "Shield"
  },
  {
    id: 6,
    title: "Custom Solutions",
    description: "From design to finishing, we offer tailored solutions to match your specific branding and marketing needs.",
    icon: "Sparkles"
  }
];

export const infrastructure = {
  title: "World-Class Infrastructure",
  description: "Our state-of-the-art manufacturing facility is equipped with precision machinery from leading international manufacturers to deliver excellence in pharmaceutical leaflet production.",
  facilities: [
    {
      id: 1,
      name: "Printing Unit",
      details: "Heidelberg SORK 512 501 Printing Machine",
      capacity: "Size: 19\" x 25\" | Speed: 10,000 sheets per hour",
      image: "https://customer-assets.emergentagent.com/job_sharad-enterprise/artifacts/taw2a8dn_heidelberg.jpg"
    },
    {
      id: 2,
      name: "Printing Unit",
      details: "Solna 225 Plus Double Colour Printing Machine (Sweden)",
      capacity: "Size: 19\" x 25\" | Speed: 7,500 sheets per hour",
      image: "https://customer-assets.emergentagent.com/job_sharad-enterprise/artifacts/l10aikcr_image.png"
    },
    {
      id: 3,
      name: "Cutting Unit",
      details: "Polar Mohr Make (Germany)",
      capacity: "Size: 32\"",
      image: "https://customer-assets.emergentagent.com/job_sharad-enterprise/artifacts/2dqwpj0e_Cutting%20Machine.JPG"
    },
    {
      id: 4,
      name: "Folding Unit",
      details: "Patankar Machines (India): High speed folding machines with 2/4/6 folds - parallel and cross",
      capacity: "Multiple fold configurations",
      image: "https://customer-assets.emergentagent.com/job_sharad-enterprise/artifacts/qxcj0gze_image.png"
    }
  ]
};

export const qualityManagement = {
  title: "Uncompromising Quality Standards",
  description: "Quality is not just a promise—it's our practice. We follow stringent quality management protocols at every stage of production.",
  processes: [
    {
      step: 1,
      title: "Raw Material Inspection",
      description: "Every batch of paper, ink, and consumables undergoes thorough quality testing before approval."
    },
    {
      step: 2,
      title: "Pre-Production Approval",
      description: "Digital proofs and color matching samples are shared with clients for approval before production begins."
    },
    {
      step: 3,
      title: "In-Process Monitoring",
      description: "Real-time quality checks during printing to ensure color consistency and registration accuracy."
    },
    {
      step: 4,
      title: "Final Inspection",
      description: "Comprehensive inspection of finished products for print quality, cutting accuracy, and finishing standards."
    },
    {
      step: 5,
      title: "Packaging & Dispatch",
      description: "Careful packaging and quality seal before dispatch to ensure products reach clients in perfect condition."
    }
  ],
  certifications: []
};

export const enquirySubmissions = [];
export const sampleRequests = [];
